import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Container, Stack } from '@mui/material';
import styles from './LegalFooter.module.scss';
import { routes } from '../../../config/routes/routes';
import { colors } from '../../styles/colors';

export const LegalFooter = () => {
  return (
    <Box component="footer" className={styles.legalFooter}>
      <Container maxWidth="lg">
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={2}
          divider={
            <Box
              aria-hidden
              sx={{
                width: '1px',
                height: '14px',
                flexShrink: 0,
                backgroundColor: colors.dividerBorderColor,
              }}
            />
          }
        >
          <Link
            to={routes.public.privacyPolicy}
            className={styles.footerLink}
            style={{ color: colors.textSubtitleColor }}
          >
            Privacy Policy
          </Link>
          <Link
            to={routes.public.termsOfService}
            className={styles.footerLink}
            style={{ color: colors.textSubtitleColor }}
          >
            Terms of Service
          </Link>
        </Stack>
      </Container>
    </Box>
  );
};

export default LegalFooter;
